import React from "react";

/**
 * Format a quantity + unit for display, e.g. "2 pieces" or "150 g".
 * Falls back gracefully when either half is missing.
 *
 * @param {number|null} quantity
 * @param {string} unitLabel
 * @returns {string}
 */
const formatQuantity = (quantity, unitLabel) => {
  if (quantity === null && !unitLabel) return "";
  if (quantity === null) return unitLabel;
  return unitLabel ? `${quantity} ${unitLabel}` : String(quantity);
};

/**
 * The food items a client tagged on a plate photo, read-only.
 *
 * Mirrors the quantity-pill treatment used in the diet feature
 * (features/diet/ui/meal-slot/FoodItemCard) without pulling in that card's
 * fixed width or its edit/sync wiring.
 *
 * @param {Object} props
 * @param {import('../../utils/commsAttachments').ChatFoodItem[]} props.items
 */
export const FoodItemsList = ({ items }) => {
  if (!items || !items.length) return null;

  const reportedByClient = items.some((item) => item.source === "USER");

  return (
    <div className="mt-2 rounded-lg border border-orange-100 bg-orange-50/60 p-2">
      <p className="mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-orange-700">
        {reportedByClient ? "Reported by client" : "Food items"}
      </p>
      <ul className="flex flex-col gap-1">
        {items.map((item, i) => {
          const quantity = formatQuantity(item.quantity, item.unitLabel);
          return (
            <li
              key={`${item.itemName}-${i}`}
              className="flex items-center justify-between gap-2 text-xs"
            >
              <span className="min-w-0 truncate text-gray-800">
                {item.itemName}
              </span>
              {quantity && (
                <span className="flex-shrink-0 rounded-md bg-white px-2 py-0.5 text-xs font-bold text-orange-700">
                  {quantity}
                </span>
              )}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FoodItemsList;
